import { ThemeProvider } from '@ori-ui/mui';
import { useCultureContext, ClientCultureContextProvider } from '@ori/culture-provider';
import { TestIdProvider } from '@ori/testid-generator';
import type { FC } from 'react';
import { IntlProvider } from 'react-intl';

import { MiniBagWrapper } from '~/components';
import { BasketLinkContextProvider, ConfigurationProvider } from '~/contexts';
import type { AppConfiguration } from '~/models';

interface AppProps {
  isECatalogue: boolean;
  configuration: AppConfiguration;
}

export const App: FC<AppProps> = ({ isECatalogue, configuration }) => {
  const { staticApiUrl, tenant, translations, goToBasketUrl, isBasketSharingEnabled } =
    configuration;
  const { getSelectedCultureCode } = useCultureContext();
  const cultureCode = getSelectedCultureCode() ?? document.documentElement.lang;

  return (
    <ConfigurationProvider value={configuration}>
      <ThemeProvider
        enableCacheProvider
        cacheKey="ori-mini-bag"
      >
        <ClientCultureContextProvider
          host={staticApiUrl}
          tenant={tenant}
        >
          <BasketLinkContextProvider value={goToBasketUrl}>
            <IntlProvider
              locale={cultureCode}
              messages={translations}
            >
              <TestIdProvider
                team="Checkout"
                project="shopping-mini-bag"
              >
                <MiniBagWrapper
                  isECatalogue={isECatalogue}
                  isBasketSharingEnabled={isBasketSharingEnabled}
                />
              </TestIdProvider>
            </IntlProvider>
          </BasketLinkContextProvider>
        </ClientCultureContextProvider>
      </ThemeProvider>
    </ConfigurationProvider>
  );
};
